import {call, put, select} from '@redux-saga/core/effects';
import {layoutActions} from 'features/layout/redux';
import selectors from 'features/layout/redux/selectors';
import history from 'redux/history';
import qs from 'query-string';
import {isDialogActive} from './isDialogActiveSaga';

export function* closeDialog(dialogId: string) {
   const isActive = (yield call(isDialogActive, dialogId)) as boolean;
   const isActiveState = (yield select(selectors.isDialogActive, dialogId)) as ReturnType<
      typeof selectors.isDialogActive
   >;

   if (isActive) {
      if (isActiveState) {
         yield put(layoutActions.closeSubDialog(dialogId));
         return;
      }
      const parsedQuery = qs.parse(window.location.search);
      if (parsedQuery?.dialog === dialogId) {
         const {dialog, ...rest} = parsedQuery;
         history.push({search: qs.stringify(rest)});
      }
   }
}
